/** @file bookings/grid.js — dock-manager grid helpers. */
import { supabase } from "@/lib/supabaseClient";

export async function listBookingsForGrid(siteId, startISO, endISO) {
  return supabase
    .from("lbs_bookings")
    .select(
      `id, reference_number, scheduled_start, scheduled_end, status, direction,
       sender_name, receiver_name, sender_company, receiver_company,
       vehicle_type, vehicle_regos, title, site_id, bay_id, client_id,
       po_number, manifest_number, internal_ref, external_ref,
       recurring_pattern_id, assigned_driver_id, driver_tba, declarations,
       driver:lbs_user_profiles!lbs_bookings_assigned_driver_id_fkey(first_name,last_name),
       bay:lbs_bays!lbs_bookings_bay_id_fkey(id,name,code,color)`
    )
    .eq("site_id", siteId)
    .lt("scheduled_start", endISO)
    .gt("scheduled_end", startISO)
    .order("scheduled_start", { ascending: true });
}

/** Occupancy-only rows (no details) — lets bookers see taken slots they can't read. */
export async function listBusySlots(siteId, startISO, endISO) {
  return supabase.rpc("lbs_site_busy_slots", { p_site_id: siteId, p_from: startISO, p_to: endISO });
}

export async function listBlackoutsForGrid(siteId, startISO, endISO) {
  return supabase
    .from("lbs_blackouts")
    .select("id,site_id,bay_id,start_time,end_time,reason,title,is_full_day,created_by_role")
    .eq("site_id", siteId)
    .lt("start_time", endISO)
    .gt("end_time",   startISO);
}

/* =====================  RECURRING PATTERNS  ================ */
